import { matchPath, useLocation, useOutlet } from 'react-router-dom';
import styled from 'styled-components';
import { SideNav } from './SideNav';
import brandConfig from '../config/brand';

import { useCheckToken } from '../modules/auth/hooks/useCheckToken';
import { useSelector } from 'react-redux';
import { authSelector } from '../modules/auth/state/authSlice';
import { TopNav } from './TopNav';
import { useState } from 'react';
import { SideViewer } from './SideViewer';
import { HomeIcon } from '../assets/icons/home';
import { CameraIcon } from '../assets/icons/camera';
import { PtzCameraIcon } from '../assets/icons/ptzCamera';
import { ActivateIcon } from '../assets/icons/activate';
import { BasketIcon } from '../assets/icons/basket';
import { LivestreamIcon } from '../assets/icons/livestream';
import { AdminShareButton } from './AdminShareButton';
import { AdminUserSwitcher } from './AdminUserSwitcher';
import { StreamingProviderNotice } from './StreamingProviderNotice';

export type NavOptionType = {
  isSelected: boolean;
  icon: JSX.Element;
  to: string;
  name: string;
  isExternal?: boolean;
  isNew?: boolean;
};

export const Layout = () => {
  const { token } = useSelector(authSelector);
  const isAuthenticated = Boolean(token);
  const outlet = useOutlet();
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();

  useCheckToken();

  const allNavOptions: NavOptionType[] = [
    {
      isSelected: Boolean(matchPath('/dashboard', pathname)),
      icon: <PtzCameraIcon size={25} color={matchPath('/dashboard', pathname) ? 'white' : 'black'} />,
      to: '/dashboard',
      name: 'Account'
    },
    {
      isSelected: Boolean(matchPath('/activate', pathname)),
      icon: <ActivateIcon size={25} color={matchPath('/activate', pathname) ? 'white' : 'black'} />,
      to: '/activate',
      name: 'Activate'
    },
    {
      isSelected: Boolean(matchPath('/livestreaming', pathname)),
      icon: <LivestreamIcon size={25} color={matchPath('/livestreaming', pathname) ? 'white' : 'black'} />,
      to: '/livestreaming',
      name: 'Livestreaming',
      isNew: true
    },
    {
      isSelected: false,
      icon: <BasketIcon color={'black'} />,
      to: brandConfig.name === 'farmstream' ? 'https://www.farmstream.co.uk/' : 'https://www.4gcctv.com/',
      name: brandConfig.name === 'farmstream' ? 'farmstream.co.uk' : '4gcctv.com',
      isExternal: true
    }
  ];

  // Filter out livestreaming for 4GCCTV brand
  const navOptions = brandConfig.name === '4gcctv' 
    ? allNavOptions.filter(option => option.name !== 'Livestreaming')
    : allNavOptions;

  return (
    <Container>
      <AdminUserSwitcher />
      <AdminShareButton />
      {isAuthenticated && <TopNav onToggle={() => setIsOpen(!isOpen)} />}
      {isAuthenticated && <SideNav navOptions={navOptions} />}
      <Wrapper>
        {outlet}
        {pathname === '/activate' && <StreamingProviderNotice />}
      </Wrapper>
      <SideViewer isOpen={isOpen} onToggle={() => setIsOpen(!isOpen)} navOptions={navOptions} />
    </Container>
  );
};

const Wrapper = styled.div`
  width: 100%;
  @media (max-width: 850px) {
    padding-top: 1rem;
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  max-width: 85rem;
  margin: 0 auto;
  min-height: 100dvh;
  padding: 1rem;

  @media (max-width: 850px) {
    flex-direction: column;
    padding: 0;
    min-height: 100dvh;
  }
`;
